export const loginType = {
    'Facebook' : '페이스북',
    'Kakao' : '카카오톡',
    'Google' : '구글',
    'Apple' : '애플',
}
// loginTypeName(type) {
//     switch (type) {
//         case 'Facebook':
//             return '페이스북';
//         case 'Kakao':
//             return '카카오톡';
//         case 'Google':
//             return '구글';
//         case 'Apple':
//             return '애플';
//         default:
//             return '이메일계정'
//     }
// },